import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import i18n from "./i18n";

Vue.config.productionTip = false;

// 全局视口管理混入
Vue.mixin({
  methods: {
    $updateViewport(width) {
      const viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        if (width === 'device-width') {
          viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
        } else {
          // 统一使用强制宽度缩放
          viewport.setAttribute('content', `width=${width}`);
        }
      }
    }
  }
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
